/** Default locale metadata for curated feeds when catalog rows omit explicit values. */
export const RSS_DIRECTORY_DEFAULT_LANGUAGE = 'pt-BR'
export const RSS_DIRECTORY_DEFAULT_COUNTRY = 'BR'

export function normalizeRssDirectoryCountryCode(value: string | null | undefined): string {
  const trimmed = value?.trim().toUpperCase() ?? ''
  if (trimmed.length === 2) {
    return trimmed
  }
  return RSS_DIRECTORY_DEFAULT_COUNTRY
}

export function normalizeRssDirectoryLanguageTag(value: string | null | undefined): string {
  const trimmed = value?.trim()
  if (trimmed) {
    return trimmed
  }
  return RSS_DIRECTORY_DEFAULT_LANGUAGE
}

export function resolveRssDirectoryEntryLocale(input?: {
  language?: string | null
  country?: string | null
}): { language: string, country: string } {
  return {
    language: normalizeRssDirectoryLanguageTag(input?.language),
    country: normalizeRssDirectoryCountryCode(input?.country)
  }
}

export interface TRssDirectoryListingSummary {
  id: string
  label: string
  category: string
  provider: string
  language: string
  country: string
  layoutId: string
  layoutPreview: string
}

export interface TRssDirectoryDirectoryFilters {
  searchQuery?: string
  languages?: readonly string[]
  countries?: readonly string[]
  providers?: readonly string[]
}

function rssDirectoryMatchesMultiSelectFilter(
  selected: readonly string[] | undefined,
  value: string
): boolean {
  if (!selected || selected.length === 0) {
    return true
  }
  return selected.includes(value)
}

export function rssDirectoryEntryMatchesDirectoryFilters(
  summary: TRssDirectoryListingSummary,
  filters: TRssDirectoryDirectoryFilters,
  extraTokens: readonly string[] = []
): boolean {
  if (!rssDirectoryMatchesMultiSelectFilter(filters.languages, summary.language)) {
    return false
  }
  if (!rssDirectoryMatchesMultiSelectFilter(filters.countries, summary.country)) {
    return false
  }
  if (!rssDirectoryMatchesMultiSelectFilter(filters.providers, summary.provider)) {
    return false
  }
  const q = filters.searchQuery?.trim().toLowerCase() ?? ''
  if (!q) {
    return true
  }
  const haystack = [
    summary.id,
    summary.label,
    summary.category,
    summary.provider,
    summary.language,
    summary.country,
    summary.layoutId,
    summary.layoutPreview,
    ...extraTokens
  ]
    .filter((token): token is string => Boolean(token?.trim()))
    .join(' ')
    .toLowerCase()
  return haystack.includes(q)
}
